import { useState } from 'react';

import { env } from '@/shared/config/env';

/**
 * Герб команды с запасным вариантом — буквой из названия.
 *
 * Буква показывалась только когда адреса нет вовсе. Если картинка
 * не доходила — а логотипы лежат на стороннем хосте `static.sporthub.bet`
 * и кэшируются там всего час, — на месте герба навсегда оставался пустой
 * белый квадрат. На iOS это и выглядело как «логотипы не отображаются».
 *
 * `loading="lazy"`: на экране матчей до двух дюжин гербов, и без этого
 * браузер тянет их все разом, включая те, до которых игрок не долистал.
 * `decoding="async"` снимает декодирование с главного потока — в WebView
 * оно иначе конкурирует с отрисовкой списка.
 *
 * Размеры не проставляются атрибутами намеренно: их задаёт CSS каждого
 * места использования, и второе число рядом разъехалось бы с первым.
 *
 * Адрес приходит двух видов. Свой — относительный путь `/teams/1/logo?v=…`:
 * бэкенд не знает, за каким префиксом он стоит, и базу API подставляет
 * клиент. Чужой — абсолютная ссылка фида, она остаётся как есть.
 */
export function TeamCrest({
  name,
  logoUrl,
  imageClassName,
  fallbackClassName,
}: {
  name: string;
  logoUrl: string | null | undefined;
  // Классы приходят из CSS-модулей, а их типы — `string | undefined`:
  // сузить здесь значило бы заставить каждое место писать `?? ''`
  imageClassName: string | undefined;
  fallbackClassName: string | undefined;
}) {
  const [failed, setFailed] = useState(false);

  if (!logoUrl || failed) {
    return (
      <span className={fallbackClassName} aria-hidden>
        {name.slice(0, 1)}
      </span>
    );
  }

  return (
    <img
      className={imageClassName}
      src={resolveSrc(logoUrl)}
      alt=""
      aria-hidden
      loading="lazy"
      decoding="async"
      onError={() => {
        setFailed(true);
      }}
    />
  );
}

/** Относительный путь — наш, его надо привести к базе API. */
function resolveSrc(url: string): string {
  return url.startsWith('/') ? `${env.apiBaseUrl}${url}` : url;
}
